import { __awaiter } from "tslib";
import { all, put, takeLatest, getContext, select } from 'redux-saga/effects';
import { isNullOrUndefined, mergeProductPricesToProductLister } from '@as-react/common-utils';
import { ProductActionTypes, ProductRecentlyViewedActionTypes } from '../../../enums/ActionEnums';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { ProductRecentlyViewedActions } from '../actions/ProductRecentlyViewedActions.creators';
import ProductRecentlyViewedAPI from '../../../api/productRecentlyViewed/ProductRecentlyViewedAPI';
import ProductsAPI from '../../../api/ProductsAPI';
import { makeGetProductInfo } from '../../../redux/product/selectors/ProductSelector';
import { queryClient } from '@as-react/common-queries';
import { useGetProductPriceQueryOptions } from '@as-react/common-queries';
export function* loadProductRecentlyViewedSaga() {
    yield takeLatest(ProductRecentlyViewedActionTypes.GET, loadProductRecentlyViewed);
    yield takeLatest(ProductActionTypes.INIT, saveProductToLocalStorage);
}
const getAllProductDetailPriceByProductId = (productIds, servicesEndpoint, defaultRequestParams) => __awaiter(void 0, void 0, void 0, function* () {
    return yield Promise.all(productIds.map((productId) => queryClient.fetchQuery(useGetProductPriceQueryOptions(productId, defaultRequestParams.mainWebshop, Number(defaultRequestParams.shopId), { language: defaultRequestParams.language }, undefined, {
        request: { servicesEndpoint },
    }))));
});
export function* loadProductRecentlyViewed() {
    try {
        let recentlyViewedProducts = ProductRecentlyViewedAPI.getProductsFromLocalStorage();
        if (isNullOrUndefined(recentlyViewedProducts)) {
            recentlyViewedProducts = [];
        }
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const products = yield ProductsAPI.getAllProductInformation(recentlyViewedProducts, servicesEndpoint, defaultRequestParams);
        const productsPrices = yield getAllProductDetailPriceByProductId(products.map((product) => product.productId), servicesEndpoint, defaultRequestParams);
        const productsWithPrices = products.map((product) => {
            const productPrice = productsPrices.find(price => product.productId === price.productId);
            return mergeProductPricesToProductLister(product, productPrice);
        });
        const productRecentlyViewedFetchAction = ProductRecentlyViewedActions.fetchProducts(productsWithPrices);
        yield put(productRecentlyViewedFetchAction);
    }
    catch (_a) { }
}
export function* saveProductRecentlyViewedSaga() {
    yield takeLatest(ProductRecentlyViewedActionTypes.FETCH, saveProductToLocalStorage);
}
export function* saveProductToLocalStorage() {
    try {
        let products = ProductRecentlyViewedAPI.getProductsFromLocalStorage();
        const productInfo = yield select(makeGetProductInfo());
        if (isNullOrUndefined(productInfo) ||
            isNullOrUndefined(productInfo.productCode) ||
            isNullOrUndefined(productInfo.selectedColorId)) {
            return;
        }
        const product = {
            productCode: productInfo.productCode,
            colorId: productInfo.selectedColorId,
        };
        if (!products) {
            products = [];
        }
        if (products.length === ProductRecentlyViewedAPI.MAX_PRODUCT_SIZE) {
            products.pop();
        }
        if (products.length === 0) {
            products.push(product);
            LocalStorageUtil.setItem(ProductRecentlyViewedAPI.localStorageKey, products);
            ProductRecentlyViewedAPI.tryToAddProduct(product);
        }
        else if (products.length > 0 && products.length < ProductRecentlyViewedAPI.MAX_PRODUCT_SIZE) {
            ProductRecentlyViewedAPI.tryToAddProduct(product);
        }
    }
    catch (_a) { }
}
export function* eraseProductRecentlyViewedSaga() {
    yield takeLatest(ProductRecentlyViewedActionTypes.ERASE, eraseList);
}
export function* eraseList() {
    yield LocalStorageUtil.setItem(ProductRecentlyViewedAPI.localStorageKey, []);
}
export default function* productRecentlyViewedSaga() {
    yield all([loadProductRecentlyViewedSaga(), saveProductRecentlyViewedSaga(), eraseProductRecentlyViewedSaga()]);
}
